import React from "react";
import { useState } from "react";
import { Form, Button } from "react-bootstrap";

export default function SearchForm(props) {
  const [manufacturer, setManufacturer] = useState("");
  const [id340b, setId340b] = useState(props.searchParams.id_340b || "");

  const searchDisabled = () => {
    // 340B ID is a required field; shortest 340B ID is 4 characters
    return id340b.length <= 4;
  };

  return (
    <div className="jumbotron p-4 mb-3 bg-body-tertiary rounded-4">
      <Form method="GET">
        <div className="row mb-3">
          <Form.Group className="col" controlId="id_340b">
            <Form.Label>
              340B ID <small className="text-danger">*</small>
            </Form.Label>
            <Form.Control
              required
              className="form-control-sm"
              type="text"
              name="id_340b"
              placeholder="Enter 340B ID..."
              defaultValue={props.searchParams.id_340b}
              onChange={(e) => setId340b(e.target.value)}
              autoFocus={true}
            />
            <Form.Check
              type="switch"
              value="true"
              id="include_org"
              name="include_org"
              className="mt-2 text-muted fst-italic"
              label="Include all CEs in organization"
              defaultChecked={props.searchParams.include_org}
            ></Form.Check>
          </Form.Group>
          <Form.Group className="col" controlId="manufacturer_name">
            <Form.Label>Manufacturer</Form.Label>
            <Form.Select
              className="form-select-sm"
              name="manufacturer_name"
              defaultValue={props.searchParams.manufacturer}
              onChange={(e) => {
                setManufacturer(e.target.value);
              }}
            >
              <option value="">{"< All Manufacturers >"}</option>
              {props.manufacturers.map((manufacturer) => (
                <option key={manufacturer.key} value={manufacturer.key}>
                  {manufacturer.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="col" controlId="network">
            <Form.Label>Network</Form.Label>
            <Form.Select
              className="form-select-sm"
              name="network"
              defaultValue={props.searchParams.network}
            >
              <option value="">{"< Any Network >"}</option>
              {props.mailDetailNetworks.map((network) => (
                <option key={network} value={network}>
                  {network}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="col" controlId="include_deleted">
            <div className="text-muted fst-italic">Input full 340B ID to search</div>
            <Button
              type="submit"
              className="btn btn-primary btn-sm"
              style={{ marginTop: 7 }}
              disabled={searchDisabled()}
            >
              <i className="fa fa-search me-1"></i>
              Search OVI Mail Details
            </Button>
          </Form.Group>
        </div>
      </Form>
    </div>
  );
}
